"use strict";

var _classCallCheck = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _get = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/get");

var _inherits = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tilt = void 0;

var TiltAnimation_1 = require("./TiltAnimation");

var Enums_1 = require("../../../../Enums");

var ValueWithRandom_1 = require("../../ValueWithRandom");

var Tilt =
/*#__PURE__*/
function (_ValueWithRandom_1$Va) {
  _inherits(Tilt, _ValueWithRandom_1$Va);

  function Tilt() {
    var _this;

    _classCallCheck(this, Tilt);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Tilt).call(this));
    _this.animation = new TiltAnimation_1.TiltAnimation();
    _this.direction = Enums_1.TiltDirection.clockwise;
    _this.enable = false;
    _this.value = 0;
    return _this;
  }

  _createClass(Tilt, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }

      _get(_getPrototypeOf(Tilt.prototype), "load", this).call(this, data);

      this.animation.load(data.animation);

      if (data.direction !== undefined) {
        this.direction = data.direction;
      }

      if (data.enable !== undefined) {
        this.enable = data.enable;
      }
    }
  }]);

  return Tilt;
}(ValueWithRandom_1.ValueWithRandom);

exports.Tilt = Tilt;